/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryOfficeItem } from '../../models/registry-office-item';

export interface OfficeControllerDissociaUser$Params {
  idOffice: number;
  idUser: number;
}

export function officeControllerDissociaUser(http: HttpClient, rootUrl: string, params: OfficeControllerDissociaUser$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerDissociaUser.PATH, 'delete');
  if (params) {
    rb.path('idOffice', params.idOffice, {});
    rb.path('idUser', params.idUser, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeItem;
      }>;
    })
  );
}

officeControllerDissociaUser.PATH = '/registry/office/{idOffice}/user/{idUser}';
